import { render, staticRenderFns } from "./YumaHooks.vue?vue&type=template&id=141d5b6e"
import script from "./YumaHooks.vue?vue&type=script&lang=js"
export * from "./YumaHooks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports